import React from 'react';
import { Router, Link, hashHistory } from 'react-router';

import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';

import ContentClear from 'material-ui/svg-icons/content/clear';
import ContentAddCircle from 'material-ui/svg-icons/content/add-circle';
import ActionSettings from 'material-ui/svg-icons/action/settings';

import Header from '../components/header.jsx';

const CreateQuizPage = React.createClass({
	componentWillMount: function() {
		if (!localStorage.getItem('token')) {
			hashHistory.push("/login");
		}
	},
	componentDidMount: function() {
		let request = new XMLHttpRequest();
		request.open('GET', '/api/v2/images/icons');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(null);
		request.onreadystatechange = function() {
			if (request.readyState == 4) {
				if (request.status == 200) {
					this.setState({
						avatarList: JSON.parse(request.responseText)
					});
				}
			}
		}.bind(this);

		this.props.selectView(1);
	},
	getInitialState: function() {
		return {
			headerTitle: 'New Quiz',
			name: '',
			questions: [],
			icon: 'medal',
			selectedicon: 'medal',
			modalOpen: false,
			avatarList: []
		}
	},
	_handleOpen: function() {
		this.setState({
			modalOpen: true
		}, function(){
			const selectedAnimal = document.querySelector('img[data-type='+ this.state.icon + ']');
			selectedAnimal.classList.add('selected');
		});
	},
	_handleClose: function() {
		this.setState({
			modalOpen: false
		});
	},
	_displayAvatarList: function() {
		const style = {
			thumbnail: {
				height: '60px',
				width: '60px',
				margin: '.4em .5em',
				opacity: '.7',
				backgroundColor: 'transparent',
				borderRadius: 'none',
				paddingBottom: '3px',
				borderBottom: '3px solid transparent',
			}
		}
		return this.state.avatarList.map((avatar) => {
			return (
				<Avatar
					key={avatar}
					data-type={avatar}
					className="animal"
					style={style.thumbnail}
					onTouchTap={this._selectAvatar}
					src={'/images/icons/' + avatar + '.png'}
				/>
			)
		})
	},
	_selectAvatar: function(e) {
		if (document.querySelector('.selected')){
			document.querySelector('.selected').classList.remove('selected');
		}
		e.target.classList.add('selected');
		this.setState({
			selectedIcon: e.target.dataset.type
		});
	},
	_saveAvatar: function() {
		this.setState({
			icon: this.state.selectedIcon
		}, this._handleClose());
	},
	_submitQuiz: function(e) {
		e.preventDefault();

		let questionList = [];

		for (var i = 0; i < this.state.questions.length; i++) {
			questionList.push({
				question: this.state.questions[i].question.trim(),
				type: this.state.questions[i].type,
				choices: this.state.questions[i].choices
			})
		}

		if (!this.state.name.length || !questionList.length) {
			return;
		}

		let data = {
			name: this.state.name.trim(),
			questions: questionList,
			icon: this.state.icon
		}

		let request = new XMLHttpRequest;
		request.open('POST', '/api/v2/quizzes');
		request.setRequestHeader('Content-Type', 'application/json');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(JSON.stringify(data));
		request.onreadystatechange = function(){
			if (request.status == 201 && request.readyState == 4) {
				hashHistory.push('/list');
			}
		};
	},
	_submitQuestion: function(body, type, id, choices) {
		const question = {
			question: body,
			type: type,
			id: id,
			choices: choices
		}
		this.setState({questions: this.state.questions.concat([question])});
	},
	_handleName: function(e) {
		this.setState({
			name: e.target.value
		})
	},
	_deleteQuestion: function(id) {
		let copyQuestions = this.state.questions;
		for (var i = 0; i < copyQuestions.length; i++) {
			if (copyQuestions[i].id === id) {
				copyQuestions.splice(i, 1);
				this.setState({
					questions: copyQuestions
				})
			}
		}
	},
	_moveUp: function(index) {
		if (index == 0) {
			return;
		}
		var newOrderList = this.state.questions.slice();
		const item = newOrderList[index];
		newOrderList.splice(index, 1);
		newOrderList.splice(index - 1, 0, item);

		this.setState({
			questions: newOrderList
		});
	},
	_moveDown: function(index) {
		if (index == this.state.questions.length - 1) {
			return;
		}
		var newOrderList = this.state.questions.slice();
		const item = newOrderList[index];
		newOrderList.splice(index, 1);
		newOrderList.splice(index + 1, 0, item);

		this.setState({
			questions: newOrderList
		});
	},
	render: function() {
		const style = {
			title: {
				padding: '0 1em 0 3em',
				boxSizing: 'border-box',
				borderBottom: '2px solid #82CCC8',
				fontSize: '18px',
			},
			icon : {
				position: 'absolute',
				top: '1.7em',
				left: '1em',
				height: '28px',
				width: '28px',
				zIndex: '99',
				backgroundColor: 'transparent',

			},
			button: {
				position: 'fixed',
				bottom: '0px',
				width: '100%',
				height: '50px',
				backgroundColor: '#82CCC8',
				zIndex: '10',
			},
			label: {
				fontSize: '18px',
				color: '#fff'
			},
			modal: {
				width: '80%',
			},
			modalTitle: {
				color: '#82CCC8',
				padding: '.7em 1em',
			}
		};
		const avatars = this._displayAvatarList();
		const actions = [
			<RaisedButton label="Save" onTouchTap={this._saveAvatar} primary={true} />
		];

		return (
			<div className="view">
				<Header headerTitle={this.state.headerTitle} />
				<div className="create content">
					<Avatar
						style={style.icon}
						onTouchTap={this._handleOpen}
						src={'/images/icons/' + this.state.icon + '.png'}
					/>
					<TextField
						floatingLabelText="Quiz Name"
						onChange={this._handleName}
						value={this.state.name}
						fullWidth={true}
						underlineShow={false}
						style={style.title}
					/>
					<CreateQuestionBox addQuestion={this._submitQuestion} />
					<QuestionList
						qList={this.state.questions}
						deleteQuestion={this._deleteQuestion}
						moveUp={this._moveUp}
						moveDown={this._moveDown}
					/>
					<FlatButton
						label="Finish"
						onClick={this._submitQuiz}
						style={style.button}
						labelStyle={style.label}
					/>
				</div>
				<Dialog
					title="Select an icon"
					actions={actions}
					contentStyle={style.modal}
					autoScrollBodyContent={true}
					open={this.state.modalOpen}
					onRequestClose={this._handleClose}
					titleStyle={style.modalTitle}
				>
					<p>Select one:</p>
					<div className="avatars">{avatars}</div>
				</Dialog>
			</div>
		)
	}
});

const CreateQuestionBox = React.createClass({
	getInitialState: function() {
		return {
			id: 0,
			question: "",
			type: "text",
			choices: ["", ""]
		}	
	},
	_updateQuestionBody: function(val) {
		this.setState({
			question: val
		})
	},
	_updateQuestionType: function(val) {
		this.setState({
			type: val
		})
	},
	_onAddChoice: function() {
		const newChoices = this.state.choices;
		newChoices.push("");
		this.setState({choices: newChoices})
	},
	_updateOptions: function(index, val) {
		var copyChoices = this.state.choices;
		copyChoices[index] = val.trim();

		this.setState({
			choices: copyChoices
		});
	},
	_addQuestion: function(e) {
		e.preventDefault();
		let body = this.state.question;
		let type = this.state.type;
		let id = Date.now();
		let choices = [];
		if (this.state.type == 'radio') {
			for (var i = 0; i < this.state.choices.length; i++) {
				if (this.state.choices[i].length) {
					choices.push(this.state.choices[i]);
				}
			}
		}

		this.props.addQuestion(body, type, id, choices);
		this.setState({
			id: Date.now(),
			question: "",
			type: "text",
			choices: ["", ""]
		});
	},
	render: function() {
		const style = {
			marginTop: '1em',
		};

		if (this.state.type === 'radio') {
			return (
				<div key={this.state.id} className="new-question">
					<CreateQuestion question={this.state.question} updateBody={this._updateQuestionBody} />
					<CreateQuestionType type={this.state.type} updateType={this._updateQuestionType} />
					<CreateResponseOptions choices={this.state.choices} addChoice={this._onAddChoice} updateOptions={this._updateOptions} />
					<RaisedButton label="Add Question" primary={true} onClick={this._addQuestion} style={style} />
				</div>
			)
		} else {
			return (
				<div key={this.state.id} className="new-question">
					<CreateQuestion question={this.state.question} updateBody={this._updateQuestionBody} />
					<CreateQuestionType type={this.state.type} updateType={this._updateQuestionType} />
					<RaisedButton label="Add Question" primary={true} onClick={this._addQuestion} style={style} />
				</div>
			)
		}
	}
});

const CreateQuestion = React.createClass({
	_handleOnChange: function(e) {
		this.props.updateBody(e.target.value);
	},
	render: function() {
		return (
			<TextField
				hintText="Ask a question"
				floatingLabelText="Question"
				onChange={this._handleOnChange}
				fullWidth={true}
			/>
		)
	}
});

const CreateQuestionType = React.createClass({
	_handleUpdateType: function(e) {
		this.props.updateType(e.target.value);
	},
	render: function() {
		return (
			<RadioButtonGroup name="qtype" defaultSelected="text">
				<RadioButton
					value="text"
					label="Fill in the Blank"
					onClick={this._handleUpdateType}
				/>
				<RadioButton
					value="radio"
					label="Multiple Choice"
					onClick={this._handleUpdateType}
				/>
			</RadioButtonGroup>
		)
	}
});

const CreateResponseOptions = React.createClass({
	_updateOptions: function(i, e) {
		this.props.updateOptions(i, e.target.value);
	},
	render: function() {
		const style = {
			add: {
				marginLeft: '1em',
				fill: '#82CCC8',
			},
			field: {
				width: '80%',
				marginLeft: '1em',
			}
		}
		const options = this.props.choices.map(function(choice, i) {
			return (
				<TextField
					hintText="Option"
					onChange={this._updateOptions.bind(this, i)}
					style={style.field}
					key={i}
				/>
			)
		}.bind(this));
		return (
			<div className="choice-fields">
				{options}
				<ContentAddCircle onClick={this.props.addChoice} style={style.add} />
			</div>
		)
	}
});

const QuestionList = React.createClass({
	getInitialState: function() {
		return {
			reorder: false
		}
	},
	_switchEditMode: function() {
		this.setState({
			reorder: !this.state.reorder
		});
	},
	render: function() {
		const questions = this._getQuestions();
		const style = {
			position: 'absolute',
			width: 'auto',
			top: 0,
			right: 0
		}

		if (questions.length) {
			return (
				<div className="list">
					<h2>Questions</h2>
					<Toggle
						label="Reorder"
						style={style}
						onToggle={this._switchEditMode}
					/>
					{questions}
				</div>
			)
		} else {
			return null;
		}
	},
	_getQuestions: function() {
		return this.props.qList.map((question, index) => {
			return (
				<Question
					key={question.id}
					id={question.id}
					index={index}
					body={question.question}
					type={question.type}
					choices={question.choices}
					reorder={this.state.reorder}
					moveUp={this.props.moveUp}
					moveDown={this.props.moveDown}
					deleteQuestion={this.props.deleteQuestion} />
			)
		})
	}
});

const Question = React.createClass({
	_handleDelete: function() {
		this.props.deleteQuestion(this.props.id);
	},
	_moveUp: function() {
		this.props.moveUp(this.props.index);
	},
	_moveDown: function() {
		this.props.moveDown(this.props.index);
	},
	render: function() {
		const style = {
			edit: {
				fill: '#EBA97A',
				flex: '0 0 auto',
				marginLeft: '.5em',
			},
			order: {
				fill: '#ccc',
			}
		};

		if (this.props.reorder) {
			if (this.props.choices.length) {
				const optionList = this.props.choices.join(", ");
				return (
					<div className="question">
						<span>{this.props.index + 1}</span>
						<div className="text">
							<p className="body">{this.props.body}</p>
							<p className="options">Options: {optionList}</p>
						</div>
						<div className="reorder">
							<div className="up arrow" onClick={this._moveUp}></div>
							<div className="down arrow" onClick={this._moveDown}></div>
						</div>
					</div>
				)
			} else {
				return (
					<div className="question">
						<span>{this.props.index + 1}</span>
						<div className="text">
							<p className="body">{this.props.body}</p>
						</div>
						<div className="reorder">
							<div className="up arrow" onClick={this._moveUp}></div>
							<div className="down arrow" onClick={this._moveDown}></div>
						</div>
					</div>
				)
			}
		} else {
			if (this.props.choices.length) {
				const optionList = this.props.choices.join(", ");
				return (
					<div className="question">
						<span>{this.props.index + 1}</span>
						<div className="text">
							<p className="body">{this.props.body}</p>
							<p className="options">Options: {optionList}</p>
						</div>
						<ContentClear onClick={this._handleDelete} style={style.edit} />
					</div>
				)
			} else {
				return (
					<div className="question">
						<span>{this.props.index + 1}</span>
						<div className="text">
							<p className="body">{this.props.body}</p>
						</div>
						<ContentClear onClick={this._handleDelete} style={style.edit} />
					</div>
				)
			}
		}
	}
});

export default CreateQuizPage;


// WEBPACK FOOTER //
// ./src/views/create-quiz.jsx